import React, {useMemo} from 'react';
import styles from './ContactInformation.module.css'
import {UIText} from "../../../enums/UIText/UIText";
import {useAppSelector} from "../../../hooks/redux";
import {getLanguage} from "../../../store/selectors/appSelector";
import {getTextByLanguage} from "../../../enums/utils/getTextByLanguage";
import {UXContacts} from "../../../enums/UXText/UXContacts";

const ContactInformation = () => {

    const language = useAppSelector(getLanguage)


    const config = useMemo(() => {
        return [
            {
                title: getTextByLanguage(UIText.contacts.address, language),
                value: getTextByLanguage(UXContacts.address, language)
            },
            {
                title: getTextByLanguage(UIText.contacts.phone, language),
                value: getTextByLanguage(UXContacts.phone, language)
            },
            {
                title: getTextByLanguage(UIText.contacts.email, language),
                value: getTextByLanguage(UXContacts.email, language),
                type: "mail"
            },
            {
                title: getTextByLanguage(UIText.contacts.schedule, language),
                value: getTextByLanguage(UXContacts.schedule, language)
            },
        ]
    }, [language])


    return (
        <div className={styles.contactsInfoWrapper}>
            {config.map((info, index) => {
                if(info.type === 'mail') {
                    return (
                        <div key={`contactsInfoItem_${index}`} className={styles.contactsInfoItemWrapper}>
                            <h3>{info.title}</h3>
                            <a href={`mailto:${info.value}`}>{info.value}</a>
                        </div>
                    )
                }else{
                    return (
                        <div key={`contactsInfoItem_${index}`} className={styles.contactsInfoItemWrapper}>
                            <h3>{info.title}</h3>
                            <p>{info.value}</p>
                        </div>
                    )
                }
                
            })}
        </div>
    );
};

export default ContactInformation;